module.exports = {

    getPaintBlobTimeline: function(paintedBlob, opts)
    {
        opts = _.extend({
            width: 100,
            height: 0,
            zoneStartRatio: 0.25,
            zoneEndRatio: 0.65,
            duration: 3,
            paintDuration: 0.4,
            cleanTint: 0xFFFFFF,
            dirtyTints: [0],
            delay: 0
        }, opts);

        var timeline = new TimelineMax();
        var paintStartX;
        var fromX = paintedBlob.x;
        var fromY = paintedBlob.y;

        function paintBlob()
        {
            paintStartX = _.random(opts.zoneStartRatio * opts.width, opts.zoneEndRatio * opts.width);
            TweenMax.killTweensOf(paintedBlob, {tint: true});
            if (paintedBlob.paintable)
            {
                paintedBlob.tint = opts.dirtyTints[_.random(0, opts.dirtyTints.length-1)];
            } else {
                paintedBlob.tint = opts.cleanTint;
            }
        }

        function tryCleanBlob()
        {
            if (paintedBlob.cleanable && !paintedBlob.cleaning && paintedBlob.tint !== opts.cleanTint && paintedBlob.x - fromX > paintStartX)
            {
                paintedBlob.cleaning = true;
                TweenMax.to(paintedBlob, opts.paintDuration, {
                    colorProps: {
                        tint: opts.cleanTint,
                        format: 'number'
                    },
                    onComplete: function()
                    {
                        paintedBlob.cleaning = false;
                    }
                });
            }
        }

        function tryStampBlob()
        {
            /* if (paintedBlob.stampable && !paintedBlob.stamping && paintedBlob.x - fromX > paintStartX)
            {
                paintedBlob.stamping = true;
                TweenMax.to(paintedBlob, opts.paintDuration, {
                    onComplete: function()
                    {
                        paintedBlob.stamping = false;
                    }
                });
            }*/
        }

        var blobTween = TweenMax.to(paintedBlob, opts.duration, {
            x: fromX + opts.width,
            y: fromY + opts.height,
            repeat: -1,
            ease: Linear.easeNone,
            onStart: paintBlob,
            onRepeat: paintBlob,
            delay: opts.delay,
            onUpdate: function(){
                tryCleanBlob();
                tryStampBlob();
            }
        });

        timeline.add(blobTween);

        return timeline;
    },

    getAliveBlobTimeline: function(blob, opts)
    {
        opts = _.extend({
            duration: 0.5,
            ratio: 0.35
        }, opts);

        var timeline = new TimelineMax();

        timeline.to(blob.scale, opts.duration, {
            yoyo: true,
            repeat: -1,
            x: '+='+_.random(opts.ratio / 2, opts.ratio, true),
            y: '+='+_.random(opts.ratio / 2, opts.ratio, true),
            ease: Quad.easeInOut
        }, _.random(0, 0.5, true));

        return timeline;
    }
};



// WEBPACK FOOTER //
// ./js/animations/blobs.js